import { useQueryClient } from "@tanstack/react-query";
import { Eye } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { useVediComeStato } from "@/hooks/useVediCome";
import { clearVediCome } from "@/lib/vedi-come";

/**
 * Striscia di avviso mostrata quando l'impersonazione «Vedi come» è attiva.
 * Ricorda che la vista è di un altro profilo ed è in sola lettura, con
 * scorciatoia per tornare alla propria identità.
 */
export function VediComeBanner() {
  const attivo = useVediComeStato();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  if (!attivo) return null;

  function tornaAMe() {
    clearVediCome();
    queryClient.invalidateQueries();
    navigate("/", { replace: true });
  }

  return (
    <div className="bg-amber-500 text-amber-950">
      <div className="mx-auto flex max-w-7xl items-center gap-3 px-6 py-1.5 text-xs">
        <Eye className="size-3.5 shrink-0" />
        <span className="truncate">
          Stai vedendo come <strong>{attivo.label}</strong>
          {attivo.tipo === "ruolo" ? " (ruolo)" : ""} · sola lettura
        </span>
        <button
          type="button"
          onClick={tornaAMe}
          className="ml-auto shrink-0 rounded bg-amber-950/10 px-2 py-0.5 font-medium hover:bg-amber-950/20"
        >
          Torna a te
        </button>
      </div>
    </div>
  );
}
